import styles from './Navigator.module.scss'
import { useRouter } from 'next/router'
import { useEffect, useState, useRef } from 'react'
import chevronIcon from '@bww/beke-ui/icons/chevron-right.svg'
import Link from 'next/link'

import classNames from 'classnames'

export default function Navigator({ items }) {
  const router = useRouter()
  const [activeItemIndex, setActiveItemIndex] = useState(0)

  const navToStep = (index) => {
    if (index !== activeItemIndex) {
      router.replace({ hash: items[index].id }, undefined, {
        shallow: true,
        scroll: false,
      })
      setActiveItemIndex(index) // !BUG this shouldn't be necessary
    }
  }

  useEffect(() => {
    const handleSectionChange = () => {
      const hashItemIndex = items.findIndex((item) =>
        location.hash.endsWith(item.id),
      )
      if (hashItemIndex >= 0 && hashItemIndex !== activeItemIndex)
        setActiveItemIndex(hashItemIndex)
    }

    window.addEventListener('section-change', handleSectionChange)

    return () => {
      window.removeEventListener('section-change', handleSectionChange)
    }
  }, [items, activeItemIndex, router.events])

  const activeItem = items[activeItemIndex]

  return (
    <nav className={styles.nav}>
      <button
        className={styles.navButton}
        disabled={activeItemIndex === 0}
        onClick={() => {
          navToStep(activeItemIndex - 1)
        }}
      >
        <svg width=".7em" height=".7em" viewBox="0 0 256 256">
          <use href={`${chevronIcon.src}#icon`} />
        </svg>
      </button>
      <div className={styles.items}>
        {items.map(({ id }, i) => {
          if (i === activeItemIndex)
            return (
              <div key={id} className={styles.activeItem}>
                <div className={styles.activeItem__step}>
                  <span>Step</span>
                  {activeItemIndex + 1}
                </div>
                <div className={styles.activeItem__title}>
                  {activeItem.title}
                </div>
              </div>
            )
          return (
            <Link
              key={id}
              className={styles.item}
              href={`#${id}`}
              scroll={false}
              shallow={true}
              replace={true}
            >
              {i + 1}
            </Link>
          )
        })}
      </div>
      <button
        className={styles.navButton}
        disabled={activeItemIndex === items.length - 1}
        onClick={() => {
          navToStep(activeItemIndex + 1)
        }}
      >
        <svg width=".7em" height=".7em" viewBox="0 0 256 256">
          <use href={`${chevronIcon.src}#icon`} />
        </svg>
      </button>
    </nav>
  )
}

export const NavigatorBanner = ({ children }) => {
  const [isSticky, setIsSticky] = useState(false)
  const bannerRef = useRef(null)

  useEffect(() => {
    const cachedRef = bannerRef.current
    const observer = new IntersectionObserver(
      ([e]) => {
        setIsSticky(e.intersectionRatio < 1 && e.boundingClientRect.top < 0)
      },
      {
        threshold: [1],
      },
    )

    observer.observe(cachedRef)

    // unmount
    return () => {
      observer.unobserve(cachedRef)
    }
  }, [])

  return (
    <div ref={bannerRef} className={styles.bannerWrapper}>
      <div
        className={classNames(styles.navigatorBanner, {
          [styles.isSticky]: isSticky,
        })}
      >
        {children}
      </div>
    </div>
  )
}
